import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { IScopeFilterProps } from '../types';

export const ScopeFilters = ({ className, children, ...rest }: IScopeFilterProps) => (
  <div className={mergeClasses('scope-filters', className)}>
    {
      React.Children.map(children, (child) => child && React.isValidElement(child) && React.cloneElement(child, { ...rest }))
    }
  </div>
);

ScopeFilters.defaultProps = {
  className: '',
};
